var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lineCode"},[_c('section',{staticClass:"main"},[_c('BarcodePopup',{attrs:{"isPop":false,"isLineCode":true}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }